<template>
  <div class="d-flex flex-column align-center pa-6 pa-sm-12">
    <div class="title mb-12">Nothing found at this URL</div>
    <div class="d-flex justify-center flex-wrap ma-n2">
      <v-btn
        v-for="[ name, icon, title ] in [
          [ 'catalog', mdiCards, 'View all cards' ],
          [ 'catalog-video', mdiVideoVintage, 'View all video themes' ],
          ...(global.xgc ? [] : [ [ 'catalog-gift-cards', mdiWalletGiftcard, 'View all gift cards' ] ])
        ]"
        :key="name"
        class="ma-2" style="text-transform: none;"
        text color="pink"
        :to="{ name }"
      >
        <v-icon class="mr-2" v-html="icon" />{{title}}
      </v-btn>
    </div>
    <div class="mt-12 text-center">
      Think you're seeing this page in error? Please let us know!<br>
      <a href="mailto:support@ellacard.com">support@ellacard.com</a>
    </div>
    <v-spacer />
  </div>
</template>

<script>
import { mdiCards, mdiVideoVintage, mdiWalletGiftcard } from '@mdi/js';

export default {
  name: 'route-not-found',

  routerViewMeta: {
    $index: false
  },

  created() {
    Object.assign(this, { mdiCards, mdiVideoVintage, mdiWalletGiftcard });
  }
}
</script>
